<template>
  <small v-if="hint" class="form-text text-muted">{{ hint }}</small>
</template>

<script>
export default {
  name: 'FHint',
  props: {
    hint: String
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FormFields/Base/FHint.vue